// This is used in getEnvs so using process here to avoid a dependency cycle
// eslint-disable-next-line regex/invalid-error
export const isCodegenRun = process.env.NEXT_PUBLIC_IS_CODEGEN_RUN === 'true'
